import { patientApi } from '@/api/PatientApi'
import { useInfiniteQuery } from '@tanstack/react-query'

export const COMPLETED_FORMS_QUERY_KEY = ['completed-forms']

const PAGE_SIZE = 10

/** The patient's submitted forms, newest first, a page at a time as they ask for more. */
const useFetchCompletedForms = () => {
	const { data, isLoading, isError, fetchNextPage, hasNextPage, isFetchingNextPage } =
		useInfiniteQuery({
			queryKey: COMPLETED_FORMS_QUERY_KEY,
			queryFn: ({ pageParam }) => patientApi.getCompletedForms(pageParam, PAGE_SIZE),
			initialPageParam: 0,
			getNextPageParam: (lastPage) =>
				lastPage.pageNumber + 1 < lastPage.totalPages
					? lastPage.pageNumber + 1
					: undefined,
			staleTime: 30000,
		})

	return {
		completedForms: data?.pages.flatMap((page) => page.content) ?? [],
		isLoading,
		isError,
		fetchNextPage,
		hasNextPage,
		isFetchingNextPage,
	}
}

export { useFetchCompletedForms }
